import Router from '@app/Router'
import { BrowserRouter } from 'react-router'
import Footer from '@components/Footer'

function App() {

  return (
    <BrowserRouter>
        <Router/>
    </BrowserRouter>
  )
}

export default App
